import React, { useEffect, useState } from "react";
import { formatCurrencyVND } from "../utils/CurrencyFormat";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { getProvinces, getDistricts } from "vietnam-provinces";
import MoMo from "../assets/images/logo-momo.png";
import { Box, CircularProgress } from "@mui/material";

const Order = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [districtsAll, setDistrictsAll] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [formData, setFormData] = useState({
    isVat: false,
    isReceive: false,
  });
  const [isCreateUser, setIsCreateUser] = useState(false);
  const [errors, setErrors] = useState({});
  const [radioOption, setRadioOption] = useState(3);
  const [loading, setLoading] = useState(false);

  const handleChange = (event) => {
    setRadioOption(Number(event.target.value));
  };

  const clientId = localStorage.getItem("client_id");
  const cart = JSON.parse(localStorage.getItem("cart")) || [];
  const coupons = JSON.parse(localStorage.getItem("coupons")) || "";
  useEffect(() => {
    window.scrollTo(0, 0);
    getDataCart(cart);
    setProvinces(getProvinces());
    setDistrictsAll(getDistricts());
  }, []);

  const getDataCart = (cart) => {
    setData(cart);
    setFormData({ ...formData, totalPrice: calculateTotal() });
  };

  const handleProvinceChange = (e) => {
    const provinceName = e.target.value;
    setSelectedProvince(provinceName);
    setErrors({ ...errors, province: "" });

    const selectedProvinceData = provinces.find(
      (province) => province.name === provinceName
    );
    if (selectedProvinceData) {
      const selectedDistrictData = districtsAll.filter(
        (districts) => districts.province_name === selectedProvinceData.name
      );
      setDistricts(selectedDistrictData ?? []);
    } else {
      setDistricts([]);
      setSelectedDistrict(``);
    }
  };

  const handleDistrictChange = (e) => {
    setSelectedDistrict(e.target.value);
    setErrors({ ...errors, district: "" });
  };

  const calculateTotal = () => {
    let cart = JSON.parse(localStorage.getItem("cart")) || [];

    const total = cart.reduce((sum, product) => {
      return sum + product.product.price * product.quantity;
    }, 0);

    if (coupons) {
      return total - Number(coupons.price);
    }

    return total;
  };

  const totalPriceRecord = () => {
    let cart = JSON.parse(localStorage.getItem("cart")) || [];

    const total = cart.reduce((sum, product) => {
      return sum + product.product.price * product.quantity;
    }, 0);

    return total;
  };

  const reduceByThousand = (number) => {
    return Math.floor(number / 1000);
  };

  const handleOrder = () => {
    formData.province = selectedProvince;
    formData.district = selectedDistrict;
    formData.payment = radioOption;
    if (formData.isReceive) {
      formData.fullNameReceive = formData.fullName;
      formData.phoneReceive = formData.phone;
    }
    const errors = validateForm(formData);
    if (Object.keys(errors).length > 0) {
      toast("Thông tin bị thiếu hoặc sai định dạng!", {
        type: "error",
        autoClose: 1000,
      });
      setErrors(errors);
    } else {
      setLoading(true);
      const reqData = {
        customerId: clientId,
        fullName: formData.fullName,
        phone: formData.phone,
        email: formData.email,
        isReceive: formData.isReceive,
        fullNameReceive: formData.fullNameReceive,
        phoneReceive: formData.phoneReceive,
        district: formData.district,
        province: formData.province,
        address: formData.address,
        orderTime: formData.orderTime,
        totalPrice: formData.totalPrice,
        message: formData.message,
        isVat: formData.isVat,
        note: formData.note,
        payment: formData.payment,
      };

      if (formData.isVat) {
        reqData.companyName = formData.companyName;
        reqData.companyTax = formData.companyTax;
        reqData.companyEmail = formData.companyEmail;
        reqData.companyAddress = formData.companyAddress;
        reqData.vatPrice = (formData.totalPrice * 10) / 100;
        reqData.totalPrice =
          formData.totalPrice +
          (formData.totalPrice * 10) / 100 -
          Number(coupons.price);
      }
      axios
        .post(`/api/v1/orders`, reqData)
        .then((res) => {
          createDetailOrder(cart, res.data.order.id);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
  };

  const validateForm = (formData) => {
    const errors = {};

    if (!formData.fullName || formData.fullName.trim() === "") {
      errors.fullName = "Vui lòng nhập họ và tên.";
    }

    const phoneRegex = /^(0[3|5|7|8|9])+([0-9]{8})$/;
    if (!formData.phone || formData.phone.trim() === "") {
      errors.phone = "Vui lòng nhập số điện thoại";
    } else if (formData.phone && !phoneRegex.test(formData.phone)) {
      errors.phone = "Số điện thoại không hợp lệ.";
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email || formData.email.trim() === "") {
      errors.email = "Vui lòng nhập email";
    } else if (formData.email && !emailRegex.test(formData.email)) {
      errors.email = "Email không hợp lệ.";
    }

    if (!formData.fullNameReceive || formData.fullNameReceive.trim() === "") {
      errors.fullNameReceive = "Vui lòng nhập tên người nhận.";
    }

    if (!formData.province || formData.province.trim() === "") {
      errors.province = "Vui lòng chọn tỉnh/thành phố.";
    }

    if (!formData.district || formData.district.trim() === "") {
      errors.district = "Vui lòng chọn quận/huyện.";
    }

    if (!formData.address || formData.address.trim() === "") {
      errors.address = "Vui lòng nhập địa chỉ.";
    }

    if (!formData.orderTime) {
      errors.orderTime = "Vui lòng chọn thời gian đặt hàng.";
    } else {
      const orderTime = new Date(formData.orderTime);
      if (isNaN(orderTime.getTime())) {
        errors.orderTime = "Thời gian đặt hàng không hợp lệ.";
      }
    }

    if (formData.isVat) {
      if (!formData.companyName || formData.companyName.trim() === "") {
        errors.companyName = "Vui lòng nhập tên công ty.";
      }

      if (!formData.companyTax || formData.companyTax.trim() === "") {
        errors.companyTax = "Vui lòng nhập mã số thuế công ty.";
      }

      if (!formData.companyEmail || formData.companyEmail.trim() === "") {
        errors.companyEmail = "Vui lòng nhập email công ty";
      } else if (
        formData.companyEmail &&
        !emailRegex.test(formData.companyEmail)
      ) {
        errors.companyEmail = "Email công ty không hợp lệ.";
      }

      if (!formData.companyAddress || formData.companyAddress.trim() === "") {
        errors.companyAddress = "Vui lòng nhập địa chỉ công ty.";
      }
    }

    return errors;
  };

  const createDetailOrder = async (data, orderId) => {
    try {
      const requests = data.map((item) =>
        axios.post(`/api/v1/order-details`, {
          quantity: item.quantity,
          productId: item.product.id,
          orderId: orderId,
        })
      );

      const res = await Promise.all(requests);
      toast("Đặt hàng thành công!", {
        type: "success",
        autoClose: 1000,
      });
      localStorage.setItem("cart", "[]");
      localStorage.removeItem("coupons");
      navigate(`/`);
    } catch (error) {
      console.error("API Error:", error);
      setLoading(false);
    }
  };

  const createCustomer = async () => {
    axios
      .post(`/api/v1/customers`, {
        username: formData.phone,
        email: formData.email,
        password: formData.phone,
      })
      .then((res) => {
        handleLogin(formData.phone, formData.phone);
      })
      .catch((err) => console.log(err));
  };

  const handleLogin = (a, b) => {
    axios
      .post(`/api/v1/customers/login`, {
        username: a,
        password: b,
      })
      .then((res) => {
        toast("Đăng nhập thành công!", {
          type: "success",
          autoClose: 1000,
        });
        localStorage.setItem("client_token", res.data.clientToken);
        localStorage.setItem("client_id", res.data.clientId);
        navigate(`/`);
      })
      .catch((err) => {
        toast(err.response.data.message, {
          type: "error",
          autoClose: 1000,
        });
      });
  };

  return (
    <div className="order-container mt-4">
      <div className="order-title">Thông Tin Đặt Hàng</div>
      <div className="order-middle">
        {!clientId && (
          <p style={{ textAlign: "start" }}>
            Bạn đã có tài khoản?{" "}
            <Link to={`/login`} className="order-login-link">
              Ấn vào đây để đăng nhập
            </Link>
          </p>
        )}
        {/* <div style={{ textAlign: "start" }}>
          Nếu chưa có tài khoản hãy tích ô "Tạo tài khoản mới" Để tích điểm nhé!
          Sở hữu ngay <b>{reduceByThousand(calculateTotal())}</b> Vip Points (
          Tương ứng{" "}
          <b>{formatCurrencyVND(reduceByThousand(calculateTotal()) * 30)}</b>)
        </div> */}
      </div>
      <div className="order-layout">
        <div className="order-left">
          <div className="order-left-title">THÔNG TIN THANH TOÁN</div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "30px",
            }}
          >
            <div>
              <div className="login-signup-label">
                Họ và tên <i className="">*</i>
              </div>
              <div
                className={`login-signup-box ${
                  errors.fullName ? "input-error" : ""
                }`}
              >
                <input
                  type="text"
                  className="login-signup-input"
                  placeholder="Nhập họ và tên"
                  onChange={(e) => {
                    setFormData({ ...formData, fullName: e.target.value });
                    setErrors({ ...errors, fullName: "" });
                  }}
                />
              </div>
              {errors.fullName && (
                <p className="error-message">{errors.fullName}</p>
              )}
            </div>
            <div>
              <div className="login-signup-label">
                Số điện thoại <i className="">*</i>
              </div>
              <div
                className={`login-signup-box ${
                  errors.phone ? "input-error" : ""
                }`}
              >
                <input
                  type="text"
                  className="login-signup-input"
                  placeholder="Nhập số điện thoại"
                  onChange={(e) => {
                    setFormData({ ...formData, phone: e.target.value });
                    setErrors({ ...errors, phone: "" });
                  }}
                />
              </div>
              {errors.phone && <p className="error-message">{errors.phone}</p>}
            </div>
          </div>
          <div className="login-signup-label">
            Email <i className="">*</i>
          </div>
          <div
            className={`login-signup-box ${errors.email ? "input-error" : ""}`}
          >
            <input
              type="text"
              className="login-signup-input"
              placeholder="Nhập địa chỉ email"
              onChange={(e) => {
                setFormData({ ...formData, email: e.target.value });
                setErrors({ ...errors, email: "" });
              }}
            />
          </div>
          {errors.email && <p className="error-message">{errors.email}</p>}
          {!clientId && (
            <div className="is-receive-check">
              <input
                type="checkbox"
                className="me-2"
                onChange={(e) => setIsCreateUser(e.target.checked)}
              />
              Tạo tài khoản mới
            </div>
          )}
          <div className="is-receive-check">
            <input
              type="checkbox"
              className="me-2"
              checked={formData.isReceive}
              onChange={(e) =>
                setFormData({ ...formData, isReceive: e.target.checked })
              }
            />
            Chọn mục này nếu bạn nhận hoa luôn
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "30px",
            }}
          >
            <div>
              <div className="login-signup-label">
                Tên đầy đủ người nhận <i className="">*</i>
              </div>
              <div
                className={`login-signup-box ${
                  errors.fullNameReceive ? "input-error" : ""
                }`}
              >
                <input
                  type="text"
                  className="login-signup-input"
                  placeholder="Tên đầy đủ người nhận"
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      fullNameReceive: e.target.value,
                    });
                    setErrors({ ...errors, fullNameReceive: "" });
                  }}
                />
              </div>
              {errors.fullNameReceive && (
                <p className="error-message">{errors.fullNameReceive}</p>
              )}
            </div>
            <div>
              <div className="login-signup-label">Số điện thoại người nhận</div>
              <div className="login-signup-box">
                <input
                  type="text"
                  className="login-signup-input"
                  placeholder="Số điện thoại người nhận"
                  onChange={(e) =>
                    setFormData({ ...formData, phoneReceive: e.target.value })
                  }
                />
              </div>
            </div>
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "30px",
            }}
          >
            <div>
              <div className="login-signup-label">
                Tỉnh/Thành phố <i className="">*</i>
              </div>
              <div
                className={`select-order ${
                  errors.province ? "input-error" : ""
                }`}
              >
                <select name="sort" id="sort" onChange={handleProvinceChange}>
                  <option value={``}></option>
                  {provinces.map((item, idx) => (
                    <option key={idx} value={item.name}>
                      {item.name}
                    </option>
                  ))}
                </select>
                <i className="bi bi-chevron-down"></i>
              </div>
              {errors.province && (
                <p className="error-message">{errors.province}</p>
              )}
            </div>
            <div>
              <div className="login-signup-label">
                Quận/Huyện <i className="">*</i>
              </div>
              <div
                className={`select-order ${
                  errors.district ? "input-error" : ""
                }`}
              >
                <select name="sort" id="sort" onChange={handleDistrictChange}>
                  <option value={``}></option>
                  {districts.map((item, idx) => (
                    <option key={idx} value={item.name}>
                      {item.name}
                    </option>
                  ))}
                </select>
                <i className="bi bi-chevron-down"></i>
              </div>
              {errors.district && (
                <p className="error-message">{errors.district}</p>
              )}
            </div>
          </div>
          <div className="login-signup-label" style={{ paddingTop: "15px" }}>
            Địa chỉ <i className="">*</i>
          </div>
          <div
            className={`login-signup-box ${
              errors.address ? "input-error" : ""
            }`}
          >
            <input
              type="text"
              className="login-signup-input"
              placeholder="Ghi rõ địa chỉ cụ thể"
              onChange={(e) => {
                setFormData({ ...formData, address: e.target.value });
                setErrors({ ...errors, address: "" });
              }}
            />
          </div>
          {errors.address && <p className="error-message">{errors.address}</p>}
          <div className="time-order" style={{ fontWeight: "bold" }}>
            <div className="login-signup-label" style={{ color: "#fff" }}>
              Thời gian giao hàng
            </div>
            <div
              className={`login-signup-box ${
                errors.orderTime ? "input-error" : ""
              }`}
            >
              <input
                type="date"
                className="time-order-input"
                onChange={(e) => {
                  setFormData({ ...formData, orderTime: e.target.value });
                  setErrors({ ...errors, orderTime: "" });
                }}
              />
            </div>
            {errors.orderTime && (
              <p className="error-message">{errors.orderTime}</p>
            )}
          </div>
          <div className="login-signup-label">Lời nhắn trên thiệp/banner</div>
          <div className="login-signup-box">
            <textarea
              className="order-textarea"
              rows="2"
              cols="50"
              placeholder="Nhập lời nhắn của bạn"
              onChange={(e) =>
                setFormData({ ...formData, message: e.target.value })
              }
            />
          </div>
          <div className="export-bill-gtgt">
            <div style={{ color: "#0184b7" }}>
              <input
                type="checkbox"
                className="me-2"
                checked={formData.isVat}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    isVat: e.target.checked,
                    companyName: "",
                    companyTax: "",
                    companyEmail: "",
                    companyAddress: "",
                  })
                }
              />
              Xuất hoá đơn GTGT
            </div>
            {formData.isVat && (
              <div style={{ paddingTop: "10px" }}>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "30px",
                  }}
                >
                  <div>
                    <div className="login-signup-label">
                      Tên công ty <i className="">*</i>
                    </div>
                    <div
                      className={`login-signup-box ${
                        errors.companyName ? "input-error" : ""
                      }`}
                    >
                      <input
                        type="text"
                        className="login-signup-input"
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            companyName: e.target.value,
                          });
                          setErrors({ ...errors, companyName: "" });
                        }}
                      />
                    </div>
                    {errors.companyName && (
                      <p className="error-message">{errors.companyName}</p>
                    )}
                  </div>
                  <div>
                    <div className="login-signup-label">
                      Mã số thuế <i className="">*</i>
                    </div>
                    <div
                      className={`login-signup-box ${
                        errors.companyTax ? "input-error" : ""
                      }`}
                    >
                      <input
                        type="text"
                        className="login-signup-input"
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            companyTax: e.target.value,
                          });
                          setErrors({ ...errors, companyTax: "" });
                        }}
                      />
                    </div>
                    {errors.companyTax && (
                      <p className="error-message">{errors.companyTax}</p>
                    )}
                  </div>
                </div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "30px",
                  }}
                >
                  <div>
                    <div className="login-signup-label">
                      Email công ty <i className="">*</i>
                    </div>
                    <div
                      className={`login-signup-box ${
                        errors.companyEmail ? "input-error" : ""
                      }`}
                    >
                      <input
                        type="text"
                        className="login-signup-input"
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            companyEmail: e.target.value,
                          });
                          setErrors({ ...errors, companyEmail: "" });
                        }}
                      />
                    </div>
                    {errors.companyEmail && (
                      <p className="error-message">{errors.companyEmail}</p>
                    )}
                  </div>
                  <div>
                    <div className="login-signup-label">
                      Địa chỉ <i className="">*</i>
                    </div>
                    <div
                      className={`login-signup-box ${
                        errors.companyAddress ? "input-error" : ""
                      }`}
                    >
                      <input
                        type="text"
                        className="login-signup-input"
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            companyAddress: e.target.value,
                          });
                          setErrors({ ...errors, companyAddress: "" });
                        }}
                      />
                    </div>
                    {errors.companyAddress && (
                      <p className="error-message">{errors.companyAddress}</p>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="login-signup-label">
            Ghi chú thêm về đơn hàng ( nếu có)
          </div>
          <div className="login-signup-box">
            <textarea
              className="order-textarea"
              rows="2"
              cols="50"
              onChange={(e) =>
                setFormData({ ...formData, note: e.target.value })
              }
            />
          </div>
        </div>
        <div className="order-right">
          <div className="order-right-title">ĐƠN HÀNG CỦA BẠN</div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "15px 0 7px 0",
              fontWeight: "bold",
              fontSize: "14px",
            }}
          >
            <div>SẢN PHẨM</div>
            <div>TẠM TÍNH</div>
          </div>
          <div className="order-right-content">
            {data.map((item, idx) => (
              <div className="order-right-content-layout" key={idx}>
                <div className="order-right-product">
                  {item.product.name} <b>× {item.quantity}</b>
                </div>
                <div>
                  {formatCurrencyVND(item.product.price * item.quantity)}
                </div>
              </div>
            ))}
            <div className="order-right-content-layout">
              <div className="count-temp">Tạm tính</div>
              <div className="count-temp">
                {/* {formatCurrencyVND(formData.totalPrice)} */}
                {formatCurrencyVND(totalPriceRecord())}
              </div>
            </div>
            {coupons && (
              <div className="order-right-content-layout">
                <div className="count-temp">{coupons.code}</div>
                <div className="count-temp">
                  {formatCurrencyVND(coupons.price)}
                </div>
              </div>
            )}
            <div className="order-right-content-layout">
              <div className="order-shipping">Giao hàng</div>
              <div className="order-shipping-right">Giao hàng miễn phí</div>
            </div>
            {formData.isVat && (
              <div className="order-right-content-layout">
                <div className="count-temp">VAT(10%)</div>
                <div className="count-temp">
                  {formatCurrencyVND((formData.totalPrice * 10) / 100)}
                </div>
              </div>
            )}
            <div className="order-right-content-layout">
              <div className="count-temp">Tổng</div>
              <div className="count-temp">
                {formData.isVat
                  ? formatCurrencyVND(
                      (formData.totalPrice * 10) / 100 + formData.totalPrice
                    )
                  : formatCurrencyVND(formData.totalPrice)}
              </div>
            </div>
          </div>
          {/* <div className="order-radio">
            <label>
              <input
                type="radio"
                value={1}
                checked={radioOption === 1}
                onChange={handleChange}
                className="me-2"
              />
              Thanh toán qua Ngân hàng/ATM (Offline)
            </label>
            {radioOption == 1 && (
              <div style={{ fontWeight: "normal", paddingTop: "10px" }}>
                Sau khi hoàn tất đặt hàng, quý khách CHUYỂN TIỀN bằng INTERNET
                BANKING hoặc ra ngân hàng gần nhất chuyển tiền vào tài khoản của
                Thanh Flower bằng các ngân hàng như: Vietcombank, Sacombank,
                Agribank, Techcombank, BIDV, ACB, Viettinbank…
              </div>
            )}
          </div>
          <div
            className="order-radio"
            style={{
              borderTop: "1px solid #ccc",
              borderBottom: "1px solid #ccc",
            }}
          >
            <label style={{ display: "flex", alignItems: "center" }}>
              <input
                type="radio"
                value={2}
                checked={radioOption === 2}
                onChange={handleChange}
                className="me-2"
              />
              Quét Mã MoMo
              <div className="ms-2">
                <img src={MoMo} alt="" />
              </div>
            </label>
            {radioOption == 2 && (
              <div style={{ fontWeight: "normal", paddingTop: "10px" }}>
                Hãy mở App Momo lên và chọn “QUÉT MÃ” để thanh toán nhé. LƯU Ý :
                Nội dung thanh toán vui lòng ghi như sau: : Mã Đơn Hàng + SĐT
                Đặt Hàng
              </div>
            )}
          </div> */}
          <div className="order-radio">
            <label>
              <input
                type="radio"
                value={3}
                checked={radioOption === 3}
                onChange={handleChange}
                className="me-2"
              />
              Trả tiền mặt khi nhận hàng
            </label>
            {radioOption == 3 && (
              <div style={{ fontWeight: "normal", paddingTop: "10px" }}>
                Giao hoa thu tiền với trường hợp người đặt là người nhận hoa.
                Vip FLowers từ chối giao hoa thu tiền trong một số trường hợp
              </div>
            )}
          </div>
          <div className="button-order" onClick={handleOrder}>
            Đặt hàng
          </div>
        </div>
      </div>
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1300,
          }}
        >
          <CircularProgress sx={{ color: "#0184b7" }} />
        </Box>
      )}
    </div>
  );
};

export default Order;
